import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesDashboards() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Operación", items: [
      { label: "Compras", icon: "fas fa-cart-plus", color: "#3b82f6", href: "/DashboardCompras", desc: "Tablero de compras", enabled: !!user.menu_reportes },
      { label: "Inventarios", icon: "fas fa-tshirt", color: "#06b6d4", href: "/DashboardInventarios", desc: "Tablero de inventario", enabled: !!user.menu_reportes },
      { label: "Ventas", icon: "fas fa-signal", color: "#10b981", href: "/DashboardVentas", desc: "Tablero de ventas", enabled: !!user.menu_reportes },
      { label: "Tiendas", icon: "fas fa-store", color: "#14b8a6", href: "/DashboardTiendas", desc: "Tablero de tiendas", enabled: !!user.menu_reportes },
    ]},
    { section: "Finanzas", items: [
      { label: "Cobranza", icon: "fas fa-dollar-sign", color: "#10b981", href: "/DashboardCobranza", desc: "Tablero de cobranza", enabled: !!user.menu_reportes },
      { label: "CxP", icon: "fas fa-chart-bar", color: "#ef4444", href: "/DashboardCXP", desc: "Cuentas por pagar", enabled: !!user.menu_reportes },
      { label: "Gastos", icon: "fas fa-hand-holding-usd", color: "#f59e0b", href: "/DashboardGastos", desc: "Tablero de gastos", enabled: !!user.menu_reportes },
      { label: "Balance", icon: "fas fa-chart-line", color: "#6366f1", href: "/Balance", desc: "Balance general", enabled: !!user.menu_reportes },
    ]},
    { section: "Antigüedad", items: [
      { label: "Saldos por Cobrar", icon: "fas fa-chart-line", color: "#3b82f6", href: "/AntiguedadSaldosPorCobrar", desc: "Por cobrar", enabled: !!user.menu_reportes },
      { label: "Saldos Vencidos", icon: "fas fa-chart-line", color: "#ef4444", href: "/AntiguedadSaldosVencido", desc: "Vencidos", enabled: !!user.menu_reportes },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Dashboards"
      descripcion="Tableros graficos del negocio"
      icono="fas fa-chart-bar"
      color="#8b5cf6"
      secciones={SECCIONES}
    />
  );
}

export default BotonesDashboards;
